(function() {

  const check = document.querySelector('#ArchiveNews');

  if( check ) {
    const news_controler = new ArchiveControler();
    news_controler.register_archive_container( document.getElementById('ArchiveNews') );

    news_controler.register_filter_select( document.getElementById('Filter_1') );
    news_controler.register_search_input( document.getElementById('Search') );

    news_controler.register_self_loading_classname('news__loading');
    news_controler.register_more_button_classname('button__more');
  }

})();